import React from 'react';
import './Footer.css';
import NearMeIcon from '@mui/icons-material/NearMe';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
const Footer = () => {
  return (
    <footer className="footer">
      {/* Brand Logos Section */}
      

      {/* Main Footer Content */}
      <div className="footer-content">
        {/* Left Section - Logo and Contact */}
        <div className="footer-left">
          <div >
            <img
            src={"./Images/logopageimg.jpg"}
            alt="Company Logo"
            className="footer-logo"
          />
            {/* <div className="logo-text">
              <span className="subtitle">GERMAN STANDARD GROUP</span>
            </div> */}
          </div>
          
          <div className="contact-info">
            <div className="contact-item">
              
              <PhoneIphoneIcon className="icon" />
              <a
                href="https://wa.me/97142668871"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "#333" }}
              >
                WhatsApp: +971 4 2668871</a>
            </div>
            <div className="contact-item">
            <MailIcon className="icon" />
              <a
                href="mailto:info@gsggroup.co"
                style={{ textDecoration: "none", color: "#333" }}
              >
                Email: info@gsggroup.co</a>
            </div>
            <div className="contact-item">
                <NearMeIcon className="icon" />
              <a style={{ textDecoration: "none", color: "#333" }}>Dubai, United Arab Emirates</a>
            </div>
          </div>

          <div className="social-icons">
            <a  className="social-icon facebook">f</a>
            <a  className="social-icon twitter">🐦</a>
            <a  className="social-icon email">✉</a>
            <a  className="social-icon pinterest">P</a>
            <a className="social-icon linkedin">in</a>
            <a  className="social-icon telegram">✈</a>
          </div>
        </div>

        {/* Middle Section - Categories */}
        <div className="footer-middle">
          <h3 style={{fontSize:"12px"}}>MOST POPULAR CATEGORIES</h3>
          <ul>
            <li style={{fontSize:"12px"}}>Animal Food</li>
            <li  style={{fontSize:"12px"}}>Non Food</li>
            {/* <li><a href="#" className="highlight">Brand by Cattle</a></li>
            <li><a href="#">Brand by Goat</a></li>
            <li><a href="#">Brand by Camel</a></li>
            <li><a href="#">Brand by Horse</a></li> */}
          </ul>
        </div>

        {/* Customer Services */}
        <div className="footer-services">
          <h3 style={{fontSize:"12px"}}>CUSTOMER SERVICES</h3>
          <ul>
            <li style={{fontSize:"12px"}}>Terms & Conditions</li>
            <li style={{fontSize:"12px"}}>FAQ</li>
            <li style={{fontSize:"12px"}}>Privacy Policy</li>
          </ul>
        </div>

        {/* Right Section - Download App */}
        <div className="footer-right">
          <h3>Download App</h3>
          <div className="app-buttons">
            <a  className="app-button">
              <div className="apple-icon">🍎</div>
              <div className="app-text">
                <span className="small">Download on the</span>
                <span className="large">App Store</span>
              </div>
            </a>
            <a  className="app-button">
              <div className="play-icon">▶</div>
              <div className="app-text">
                <span className="small">GET IT ON</span>
                <span className="large">Google Play</span>
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Section - Copyright and Payment */}
      <div className="footer-bottom">
        <div className="copyright">
          All Rights Reserved © <strong>2024</strong> GERMAN STANDARD GROUP .
        </div>
        <div className="payment-methods2">
          <div className="payment-card visa">VISA</div>
          <div className="payment-card mastercard">●●</div>
          <div className="payment-card maestro">⟨⟩</div>
          <div className="payment-card amex">AMEX</div>
        </div>
      </div>


    </footer>
  );
};

export default Footer;